'use client'

import { ChevronLeftIcon, ChevronRightIcon } from '@radix-ui/react-icons'
import { useCallback, useEffect, useRef, useState } from 'react'
import { T } from '@/components/t'
import { JobsApplicationCards } from './jobs-application-card'

export const JobsApplicationSection = () => {
    const scrollableDivRef = useRef<HTMLDivElement>(null)
    const [isAtStart, setIsAtStart] = useState(true)
    const [isAtEnd, setIsAtEnd] = useState(false)

    const updateButtonStates = useCallback(() => {
        if (scrollableDivRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = scrollableDivRef.current
            setIsAtStart(scrollLeft === 0)
            setIsAtEnd(scrollLeft + clientWidth >= scrollWidth)
        }
    }, [])

    const scrollLeft = () => {
        if (scrollableDivRef.current) {
            scrollableDivRef.current.scrollBy({ left: -260, behavior: 'smooth' })
        }
    }

    const scrollRight = () => {
        if (scrollableDivRef.current) {
            scrollableDivRef.current.scrollBy({ left: 260, behavior: 'smooth' })
        }
    }

    useEffect(() => {
        const scrollableDiv = scrollableDivRef.current
        if (scrollableDiv) {
            updateButtonStates()
            scrollableDiv.addEventListener('scroll', updateButtonStates)
            return () => scrollableDiv.removeEventListener('scroll', updateButtonStates)
        }
    }, [updateButtonStates])

    return (
        <section className="w-full 2xl:flex 2xl:flex-col 2xl:items-center 2xl:justify-center pb-10 md:pb-20">
            <div className="flex flex-col items-center justify-center gap-2 pb-4 md:pb-12 px-4 w-full">
                <T
                    h1
                    t="jobs.application.title"
                    className="text-center text-[24px] md:text-[32px] font-bold"
                />
                <T
                    h2
                    t="jobs.application.description"
                    className="text-center font-normal text-[16px] text-black/70 max-w-[938px]"
                />
            </div>
            <div ref={scrollableDivRef} className="overflow-x-scroll scrollbar-hide">
                <JobsApplicationCards tBaseKey="jobs.application" />
            </div>
            <div className="hidden md:flex 2xl:hidden justify-center gap-4 mt-8 pb-10">
                <button
                    onClick={scrollLeft}
                    className={`p-4 rounded-full shadow-md bg-white hover:shadow-lg ${
                        isAtStart ? 'text-gray-200' : 'text-gray-400'
                    }`}
                    disabled={isAtStart}
                >
                    <ChevronLeftIcon className="h-8 w-8" />
                </button>
                <button
                    onClick={scrollRight}
                    disabled={isAtEnd}
                    className={`p-4 rounded-full shadow-md bg-white hover:shadow-lg ${
                        isAtEnd ? 'text-gray-200' : 'text-gray-400'
                    }`}
                >
                    <ChevronRightIcon className="h-8 w-8" />
                </button>
            </div>
        </section>
    )
}
